import SnackbarContext from "UI/SnackbarContext/SnackbarContext";

const SnackbarConsumer = SnackbarContext.Consumer;

export default SnackbarConsumer;